import { SOFTWARE } from '../constant/actionTypes';

const getSoftwareVersionList = (state, action) => {
  switch (action.type) {
    case SOFTWARE.VERSION.INITIATE:
      return { isFetching: true, data: action.payload };
    case SOFTWARE.VERSION.SUCCESS:
      return { isFetching: false, data: action.payload };
    case SOFTWARE.VERSION.ERROR:
      return { isFetching: false, data: action.payload };
    default:
      return state || [];
  }
};

export default getSoftwareVersionList;
